<div class="sidebar-wrapper d-flex flex-column h-100">
  <aside class="client-sidebar d-flex flex-column h-100 bg-white border-end border-purple border-opacity-50 px-3 px-lg-4 py-4">
    <div class="d-flex align-items-center mb-3">
      <div>
        <div class="fw-bold text-x lh-sm">
          <img :src="$clientLogo" alt="Logo" class="logo-img" width="170px">
        </div>
      </div>
    </div>
 
    <div class="sidebar-content flex-grow-1 d-flex flex-column justify-content-between">
      <nav class="entity-sidebar mt-2">
        <ul class="nav flex-column gap-2">
          <li v-if="show_overview_link">
            <router-link
              to="/overview"
              class="nav-link d-flex align-items-center gap-3 text-dark fw-semibold"
              active-class="active"
              @click="close_sidebar"
            >
              <i class="bi bi-box-fill fs-5"></i>
              <span>Overview</span>
            </router-link>
          </li>
          <li v-if="show_organization_dashboard_link">
            <router-link
              :to="{ name: 'OrganizationDashboard' }"
              class="nav-link d-flex align-items-center gap-3 text-dark fw-semibold"
              active-class="active"
              @click="close_sidebar"
            >
              <i class="bi bi-building-fill-gear fs-5"></i>
              <span>Dashboard</span>
            </router-link>
          </li>
          <li v-if="show_projects_link">
            <router-link
              :to="projects_route"
              class="nav-link d-flex align-items-center gap-3 text-dark fw-semibold"
              active-class="active"
              @click="close_sidebar"
            >
              <i class="bi bi-suitcase-lg-fill fs-5"></i>
              <span>Projects</span>
            </router-link>
          </li>
          <li>
            <router-link
              to="/entity-configs"
              class="nav-link d-flex align-items-center gap-3 text-dark fw-semibold"
              active-class="active"
              @click="close_sidebar"
            >
              <i class="bi bi-gear-fill fs-5"></i>
              <span>Entity Configs</span>
            </router-link>
          </li>
          <li>
            <button
              type="button"
              class="nav-link w-100 border-0 bg-transparent d-flex align-items-center justify-content-between text-dark fw-medium"
              @click="toggle_subsystems"
              :aria-expanded="is_subsystems_open ? 'true' : 'false'"
            >
              <span class="d-flex align-items-center gap-3 fw-semibold">
                <i class="bi bi-stack fs-5"></i>
                <span>Subsystems</span>
              </span>
              <i
                class="bi small"
                :class="is_subsystems_open ? 'bi-chevron-up fs-4' : 'bi-chevron-down fs-4'"
              ></i>
            </button>
          </li>
          <li v-if="is_subsystems_open">
            <ul class="nav flex-column gap-1 ps-3">
              <li v-for="item in subsystem_items" :key="item.label">
                <router-link
                  v-if="item.routeName"
                  :to="{ name: item.routeName }"
                  active-class="active"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>{{ item.label }}</span>
                </router-link>
                <a
                  v-else
                  href="#"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            </ul>
          </li>
          <li>
            <button
              type="button"
              class="nav-link w-100 border-0 bg-transparent d-flex align-items-center justify-content-between text-dark fw-medium"
              @click="toggle_management"
              :aria-expanded="is_management_open ? 'true' : 'false'"
            >
              <span class="d-flex align-items-center gap-3 fw-semibold">
                <i class="bi bi-sliders2 fs-5"></i>
                <span>Management</span>
              </span>
              <i
                class="bi small"
                :class="is_management_open ? 'bi-chevron-up fs-4' : 'bi-chevron-down fs-4'"
              ></i>
            </button>
          </li>
          <li v-if="is_management_open">
            <ul class="nav flex-column gap-1 ps-3">
              <li>
                <router-link
                  :to="{ name: 'ManageQuestions' }"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  active-class="active"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>Manage Questions</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'DynamicCaseReport' }"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  active-class="active"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>Reports</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'ManageStatus' }"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  active-class="active"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>Statuses</span>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/users"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  active-class="active"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>Users</span>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/roles"
                  class="nav-link d-flex align-items-center gap-3 text-dark fw-medium py-1"
                  active-class="active"
                  @click="close_sidebar"
                >
                  <i class="bi bi-dot fs-5"></i>
                  <span>Roles</span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <div class="pt-4 mt-4 border-top">
        <div class="d-flex align-items-center mb-3">
          <div class="avatar-circle me-2 text-capitalize">
            {{ (currently_logged_in || '').slice(0, 1) }}
          </div>

          <div class="user-info">
            <p class="m-0 text-dark fw-bold text-xxs">{{ currently_logged_in }}</p>
            <small class="text-dark text-xxs">{{ role }}</small>
          </div>
        </div>
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 text-dark border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>
  </aside>
</div>
